// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { People, Refresh, Routing, Tag } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  discoveryTrip: Routing,
  sales: Tag,
  commercials: People,
  requests: Refresh
};

// ==============================|| MENU ITEMS - DISCOVERY TRIP ||============================== //

const discoveryTrip: NavItemType = {
  id: 'discovery-trip-group',
  title: <FormattedMessage id="common.menu.discoveryTrip.group" />,
  type: 'group',
  children: [
    {
      id: 'discoveryTrip',
      title: <FormattedMessage id="common.menu.discoveryTrip.group" />,
      url: '/discovery-trip',
      type: 'item',
      icon: icons.discoveryTrip
    },
    {
      id: 'sales',
      title: <FormattedMessage id="common.menu.discoveryTrip.sales" />,
      type: 'item',
      url: '/discovery-trip/sales',
      icon: icons.sales
    }
  ]
};

export default discoveryTrip;
